import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { formatStyles } from '../react-intl-helpers'
import { ConfirmationWarningDialog } from '../../legacy-design-system/modal'

interface DeleteAgentDialogProps {
  isOpen: boolean
  agentName?: string
  onCancel: () => void
  onConfirm: () => void
}

export const DeleteAgentDialog = ({
  isOpen,
  agentName,
  onCancel,
  onConfirm
}: DeleteAgentDialogProps) => {
  const intl = useIntl()

  const [confirmationText, setConfirmationText] = useState('')

  const validConfirmations = ['Delete', '削除']

  return (
    <ConfirmationWarningDialog
      isOpen={isOpen}
      onCancel={onCancel}
      onConfirm={onConfirm}
      renderTitle={() =>
        intl.formatMessage({
          id: 'title_warning'
        })
      }
      renderBody={() =>
        intl.formatMessage(
          { id: 'variable_userSettings_deleteAgentUser' },
          {
            agentName,
            ...formatStyles.bold,
            ...formatStyles.italic
          }
        )
      }
      confirmationDisabled={!validConfirmations.includes(confirmationText)}
      renderConfirmationInput={() => (
        <input
          type="text"
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
        />
      )}
      renderConfirmMessage={() => intl.formatMessage({ id: 'action_delete' })}
      renderCancelMessage={() => intl.formatMessage({ id: 'action_cancel' })}
    />
  )
}
